<template>
<div class="wrp-version">
    <div class="back cleat">
      <span @click="goback"><i class="el-icon-back"></i>Back</span>
      <el-button class="upload-btn" @click="upload">Upload Version Details</el-button>
    </div>
    <div class="bgd">
        <h1>Version Record</h1>
        <div class="choose clear">
            <div class="label" :class="{'active': current === 2}" @click="getList(2)">iOS App</div>
            <div class="label" :class="{'active': current === 1}" @click="getList(1)">Android App</div>
        </div>
        <el-table
			:data="tableData"
			border
			class="version_table"
			style="width: 100%">
				<el-table-column
				prop="version"
				align="left"
				class-name="roster_row"
				label="Version">
				</el-table-column>
				<el-table-column
				prop="minVersion"
				align="center"
				class-name="roster_row"
				label="Minimum Version">
				</el-table-column>
				<el-table-column
				prop="updateTime"
				align="center"
				class-name="roster_row"
				label="Update Time">
				</el-table-column>
                <el-table-column
				prop="updateDetails"
				align="center"
				class-name="roster_row"
				label="Update Details">
				</el-table-column>
                <template slot="empty">
                    <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                    <div v-else>-</div>
                </template>
		</el-table>
        <div class="ros_footerPage">
            <el-pagination
                class="my_pageSel"
                :current-page.sync="page"
                layout="prev, pager, next"
                @current-change='changePage'
                :page-size="10"
                :total="total">
            </el-pagination>
        </div>
    </div>

    <el-dialog
      title="Upload Version Details"
      :visible.sync="visible"
      :modal-append-to-body="false"
      :show-close="false"
      class="delsmsDio_box"
      :close-on-click-modal="false"
      top="40px"
      width="840px"
      center>
          <el-form :model="ruleForm" label-position="top" :hide-required-asterisk='true'
          :rules="rules" ref="ruleForm" label-width="100px" class="information-ruleForm">
                <el-form-item label="Mobile Device">
                    <div class="add-choose clear">
                        <div class="label" :class="{'active': current === 2}" @click="current = 2">iOS App</div>
                        <div class="label" :class="{'active': current === 1}" @click="current = 1">Android App</div>
                    </div>
                </el-form-item>

                <el-form-item label="Version" prop="version">
                    <el-input v-model="ruleForm.version" maxlength="30"
                    @input="ruleForm.version = ruleForm.version.replace(/[^\d.]/g,'')"
                    class="version_input"></el-input>
                </el-form-item>

                <el-form-item label="Minimum Version" prop="mini">
                    <el-input v-model="ruleForm.mini" maxlength="30"
                     @input="ruleForm.mini = ruleForm.mini.replace(/[^\d.]/g,'')"
                    class="version_input"></el-input>
                </el-form-item>

                <el-form-item label="Update Details" prop="dtls">
                    <el-input v-model="ruleForm.dtls" maxlength="500" type="textarea" resize='none' class="version_input"></el-input>
                </el-form-item>
    
            <el-form-item class="foot_box">
                <el-button @click="cancelOperate" class="cardCanBtn">Cancel</el-button>
                <el-button @click="confirm" class="cardConBtn">Upload</el-button>
            </el-form-item>
          </el-form>

    </el-dialog>
</div>
</template>
<script>
import api from '../../api/setting'

export default {
	data() {
		return {
            current: 2,

            tableData:[],
			page:1,
			size:10,
			total:0,
			loading: true,

            visible: false,
            rules:{
                version:[{ required: true, message: ' ', trigger: 'change' }],
                mini:[{ required: true, message: ' ', trigger: 'change' }],
                dtls:[{ required: true, message: ' ', trigger: 'change' }]
            },
            ruleForm:{
                version: '',
                mini: '',
                dtls: ''
            },
        }
	},
    created() {
        this.getList(2)
    },
    methods: {
        confirm() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    api.versionAdd({
                        params: {
                            version: this.ruleForm.version,
                            minVersion: this.ruleForm.mini,
                            updateDetails: this.ruleForm.dtls,
                            type: this.current,
                        },
                        callback: (res) => {
                            this.loading=false
                            let {code,message,data}=res.data;
                            this.loading2=false;
                            if(code==0){
                                this.cancelOperate()
                                this.getList(this.current)
                            }else{
                                this.$box.alert('', message, 'error')
                            }
                        }
                    })
                }
            })
        },
        cancelOperate() {
            this.visible = false
            this.ruleForm ={
                version: '',
                mini: '',
                dtls: ''
            }
            this.$refs.ruleForm.clearValidate()
        },
        upload() {
            this.visible = true
        },
        goback () {
            this.$router.go(-1)
        },
        changePage(page){
            this.page = page
            this.getList(this.current)
        },
        getList (type) {
            this.loading=true
            this.current = type
            let pat={
                type,
                pageNum:this.page,
                pageSize:this.size
            }
            api.versionList({params:pat,callback:res=>{
                this.loading=false
                let {code,message,data}=res.data;
                this.loading2=false;
                if(code==0){
                    data.list.forEach(item=>{
                        item.updateTime = Utils.formatVersionTime(item.updateTime * 1000)
                    })
                    this.tableData=data.list;
                    this.total=data.total;
                }else{
                    this.$box.alert('', message, 'error')
                }
            }})
        }
    },
    watch: {
        visible(n,o){
         
                setTimeout(() => {
                    this.$refs.ruleForm.clearValidate()
                }, 50)
            
        },
    }
}
</script>

<style lang="scss">
.wrp-version{
  color: #fff;
  padding-bottom: 50px;
  .back{
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    margin-bottom: 56px;
    font-family: 'SFProText-Semibold';
    background: #212429;
    width: 100%;
    z-index: 4;
    height: 20px;
    span{
      display: block;
      float: left;
      width: 100px;
      cursor: pointer;
      i{
        margin-right: 10px;
      }
    }
    .upload-btn{
        float: right;
        width: 324px;
        height: 60px;
        background: #151C27;
        border: 2px solid #D13A90;
        font-size: 26px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #D13A90;
        cursor: pointer;
    }
  }
  .bgd{
    width: 100%;
    background: #2B3444;
    padding: 50px 30px 65px 30px;
    margin-bottom: 50px;
    box-sizing: border-box;
    h1{
        font-family: 'PingFangSC-Semibold';
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 50px;
        text-align: center;
    }
    .ros_footerPage{
        display: flex;
        justify-content: center;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
.choose{
    height: 60px;
    background: #151C27;
    box-sizing: border-box;
    padding-left: 30px;
    .label{
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        line-height: 60px;
        float: left;
        cursor: pointer;
        margin-right: 40px;
        color: #A1A4A9;
        position: relative;
    }
    .active{
        color: #fff;
        &:after{
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background: #EA3796;
            bottom: -1px;
            left: 0;
        }
    }
}
.add-choose{
    height: 50px;
    box-sizing: border-box;
    .label{
        width: 162px;
        height: 50px;
        background: #151C27;
        border: 1px solid #5F5F5F;
        line-height: 48px;
        cursor: pointer;
        text-align: center;
        font-size: 20px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        float: left;
        margin-right: 30px;
    }
    .active{
        color: #fff;
        background: #D13A90;
        border-color: #D13A90;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/setting/version.vue